import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "../i18n/I18nContext";
import { listInactiveRegistrations, reactivateRegistration } from "../services/student";
import { getUserInfo } from "../services/auth";
import { useConfirm } from "../hook/useConfirm";

const EstudantesInactivosLayer = () => {
  const { t } = useTranslation();
  const { confirm, ConfirmModal } = useConfirm();
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState(null);

  const fetchData = () => {
    setLoading(true);
    listInactiveRegistrations()
      .then((resp) => setRegistrations(resp.data || []))
      .catch(() => toast.error(t("inactivos.error.load")))
      .finally(() => setLoading(false));
  };

  useEffect(fetchData, [t]);

  const handleReactivate = async (record) => {
    if (!(await confirm(t("inactivos.confirm.reactivate", { name: record.student?.name }), { variant: "info" })))
      return;
    setBusyId(record.id);
    try {
      await reactivateRegistration(record.id, getUserInfo()?.id);
      toast.success(t("inactivos.success.reactivated"));
      fetchData();
    } catch (err) {
      toast.error(t("inactivos.error.reactivate"));
    } finally {
      setBusyId(null);
    }
  };

  return (
    <div className='row gy-4'>
      <ToastContainer />
      <div className='col-12'>
        <div className='card radius-12'>
          <div className='card-body'>
            {loading ? (
              <div className='text-center py-40'>{t("global.loading")}</div>
            ) : registrations.length === 0 ? (
              <div className='alert alert-info mb-0'>{t("inactivos.hint.noStudents")}</div>
            ) : (
              <div className='table-responsive'>
                <table className='table bordered-table mb-0'>
                  <thead>
                    <tr>
                      <th>{t("presenca.col.name")}</th>
                      <th>{t("estudante.field.code")}</th>
                      <th>{t("global.contact")}</th>
                      <th>{t("inactivos.col.reason")}</th>
                      <th>{t("inactivos.col.inactivatedAt")}</th>
                      <th>{t("turma.col.actions")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {registrations.map((record) => (
                      <tr key={record.id}>
                        <td>{record.student?.name}</td>
                        <td>{record.student?.code || "-"}</td>
                        <td>{record.student?.mobile || record.student?.contact || "-"}</td>
                        <td>{record.inactivationReason || "-"}</td>
                        <td>{record.inactivatedAt ? new Date(record.inactivatedAt).toLocaleDateString("pt-PT") : "-"}</td>
                        <td>
                          <button
                            type='button'
                            className='btn btn-outline-success-600 btn-sm d-flex align-items-center gap-1'
                            onClick={() => handleReactivate(record)}
                            disabled={busyId === record.id}
                          >
                            <Icon icon='mdi:account-reactivate-outline' />
                            {t("inactivos.action.reactivate")}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
      {ConfirmModal}
    </div>
  );
};

export default EstudantesInactivosLayer;
